import actions from './moduleMyProfileActions'
import getters from './moduleMyProfileGetters'
import mutations from './moduleMyProfileMutations'
import state from './moduleMyProfileState'

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
}
